import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

export default function DangerActionConfirmModalComponent({
  show,
  title,
  message,
  onClose,
  onConfirm,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
  showNoteField = false,
  notePlaceholder = "Enter a note...",
  noteLabel = "Note",
}) {
  const [note, setNote] = useState("");

  if (!show) return null;

  const handleConfirm = () => {
    if (showNoteField && !note.trim()) {
      return; // Don't proceed if note field is shown but empty
    }
    onConfirm(showNoteField ? note : null);
    setNote(""); // Reset note after confirm
  };

  const handleClose = () => {
    setNote(""); // Reset note on cancel
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{
          zIndex: 1040,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1050 }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div
            className="modal-content border-0 shadow-lg"
            style={{
              borderRadius: "20px",
              maxWidth: "500px",
              margin: "auto",
            }}
          >
            {/* Modal Body */}
            <div className="modal-body text-center py-5 px-4">
              {/* Warning Icon */}
              <div className="mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                  style={{
                    width: 80,
                    height: 80,
                    backgroundColor: "#dc3545",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="text-white"
                    size="3x"
                  />
                </div>
              </div>

              {/* Title */}
              {title && (
                <h5
                  className="mb-3 fw-bold"
                  style={{
                    color: "#2c3e50",
                    fontSize: "1.5rem",
                  }}
                >
                  {title}
                </h5>
              )}

              {/* Message */}
              <p
                className="mb-4"
                style={{
                  color: "#6c757d",
                  fontSize: "1.1rem",
                  lineHeight: "1.6",
                }}
              >
                {message}
              </p>

              {/* Note Input - Only shown if showNoteField is true */}
              {showNoteField && (
                <div className="mb-4 text-start">
                  <label
                    htmlFor="actionNote"
                    className="form-label fw-semibold"
                    style={{ color: "#2c3e50", fontSize: "1rem" }}
                  >
                    {noteLabel}
                    <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    id="actionNote"
                    className="form-control"
                    rows="4"
                    placeholder={notePlaceholder}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    style={{
                      fontSize: "1rem",
                      borderRadius: "10px",
                      resize: "none",
                    }}
                  />
                  {!note.trim() && (
                    <small className="text-danger d-block mt-2">
                      This field is required
                    </small>
                  )}
                </div>
              )}

              {/* Buttons */}
              <div className="d-flex gap-3 justify-content-center">
                <button
                  type="button"
                  className="btn btn-secondary btn-lg px-4"
                  onClick={handleClose}
                  style={{
                    fontWeight: "500",
                    fontSize: "1.1rem",
                    padding: "12px 32px",
                  }}
                >
                  {cancelButtonText}
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-lg px-4"
                  onClick={handleConfirm}
                  disabled={showNoteField && !note.trim()}
                  style={{
                    fontWeight: "500",
                    fontSize: "1.1rem",
                    padding: "12px 48px",
                  }}
                >
                  {confirmButtonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
